export const RulerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8393 5.70249L14.7143 1.57748C14.3889 1.25217 13.8614 1.25217 13.536 1.57748L1.16098 13.9525C0.835663 14.2779 0.835663 14.8054 1.16098 15.1308L5.28598 19.2558C5.6114 19.5811 6.1389 19.5811 6.46431 19.2558L18.8393 6.88082C19.1646 6.5554 19.1646 6.0279 18.8393 5.70249ZM2.92941 14.5416L5.28608 12.1841L6.46441 13.3641L7.64358 12.185L6.46441 11.0066L8.23275 9.23915L10.0002 11.0066L11.1786 9.82665L9.41108 8.05998L11.1786 6.29165L12.3569 7.46998L13.5361 6.29165L12.3569 5.11331L14.1252 3.34581L17.0711 6.29165L5.87525 17.4875L2.92941 14.5416Z"
        fill="#383838"
      />
    </svg>
  )
}
